import React, { useEffect, useRef, useState } from 'react';
import '../styles/GlobalPaymentsCardEntry.css'; // Optional for styling

const GlobalPaymentsCardEntry = ({ makeThePayment, formToken, maxwidth = false, formType = 'payment' }) => {
    const formContainerRef = useRef(null);
    const cardFormRef = useRef(null);
    const [message, setMessage] = useState('');
    const [isError, setIsError] = useState(false);

    useEffect(() => {
        const initializePaymentForm = async () => {
            // Check if SDK is loaded
            if (!window.GlobalPayments) {
                setMessage('Payment system failed to load');
                setIsError(true);
                return;
            }

            const { scope: { merchant_id = '' }, token, gpEnv, gpCurrency = 'CAD', gpCountry = 'CA' } = formToken

            try {
                const gpConfig = {
                    accessToken: token, // Get this from your backend
                    apiVersion: "2021-03-22",
                    env: gpEnv,
                    fieldValidation: {
                        enabled: true
                    },
                    enableAutocomplete: true,
                }

                // if (formType === 'payment') {
                //     gpConfig['apms'] = {
                //         //currencyCode: gpCurrency,
                //         //allowedCardNetworks: ["VISA", "MASTERCARD", "AMEX", "DISCOVER"],
                //         googlePay: {
                //             currencyCode: gpCurrency,
                //             countryCode: gpCountry,
                //             merchantName: 'Quetzal Project Partners Inc.',
                //             allowedAuthMethods: ["CRYPTOGRAM_3DS"],
                //             allowedCardNetworks: ["VISA", "MASTERCARD", "AMEX", "DISCOVER"],
                //             buttonType: "plain",
                //             merchantId: "7633-2797-1360",
                //             globalPaymentsClientID: "gpapiqa1"
                //         }
                //     }
                // }

                // console.log(gpConfig);

                //Configure Global Payments
                window.GlobalPayments.configure(gpConfig);

                //Initialize credit card form
                cardFormRef.current = window.GlobalPayments.creditCard.form("#credit-card-form", {
                    style: "gp-default",
                    // apms: ["google-pay"],
                    // amount: "19.99",
                });

                // Set up event handlers
                cardFormRef.current.ready(() => {
                    // setIsLoading(false);
                });

                cardFormRef.current.on('token-success', (response) => {
                    setIsError(false);
                    // details: { apmProvider: provider }
                    const { paymentReference: token } = response;
                    makeThePayment({ token }, null);
                });

                cardFormRef.current.on('token-error', (response) => {
                    setMessage(response.message || "Payment processing failed");
                    setIsError(true);
                });

                cardFormRef.current.on('submit', 'click', (response) => {
                    // setMessage(response.message || "Card type invalid");
                    // setIsError(true);
                });

            } catch (error) {
                setMessage(error.message || "Failed to initialize payment form");
                setIsError(true);
            }
        };

        // Load SDK if not already loaded
        if (!window.GlobalPayments) {
            const script = document.createElement('script');
            script.src = 'https://js.globalpay.com/4.1.6/globalpayments.js';
            script.async = true;
            script.onload = initializePaymentForm;
            script.onerror = () => {
                setMessage('Failed to load payment system');
                setIsError(true);
            };
            document.body.appendChild(script);
        } else {
            initializePaymentForm();
        }

        return () => {
            // Cleanup
            if (cardFormRef.current?.teardown) {
                cardFormRef.current.teardown();
            }
        };
    }, []);

    return (
        <div className="payment-container" style={{ width: '100%', maxWidth: maxwidth ? '100%' : '70%', margin: '0 auto' }}>
            <form id="payment-form">
                <div id="credit-card-form" ref={formContainerRef}></div>
                {message && (
                    <div className={`message ${isError ? 'error' : 'success'}`}>
                        {message}
                    </div>
                )}
            </form>
        </div>
    );
};

export default GlobalPaymentsCardEntry;